import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { styled, useTheme } from 'styled-components';
import { Modal } from '.';
import { Button } from '../../Controls/Button';
import Icons from '../../Elements/Icons';
import Typography from '../../Typography';
const StyledModal = styled(Modal) `
  min-height: 150px;
`;
const ContentWrapper = styled.div `
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  & h5 {
    margin: 0;
  }
`;
const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ModalDialog = memo(function ModalDialog({ title, text, cancelButtonText, actionButtonText, isPendingAction, error = false, onActionButtonClick, dataTestId, ...props }) {
    const { colors } = useTheme();
    return (_jsxs(StyledModal, { width: '400px', height: 'auto', ...props, children: [_jsxs(ContentWrapper, { "data-testid": 'modal-dialog', children: [_jsxs(TitleWrapper, { children: [error && _jsx(Icons.Warning, { size: 20, color: colors.critical100, filled: true }), _jsx(Typography.SubTitle, { children: title })] }), _jsx(Typography.TextMedium, { children: text })] }), _jsxs(Modal.Footer, { "data-testid": dataTestId, children: [_jsx(Button, { ghost: true, onClick: props.state.close, disabled: isPendingAction, dataTestId: 'cancel-button', children: cancelButtonText }), _jsx(Button, { primary: !error, critical: error, onClick: onActionButtonClick, isLoading: isPendingAction, disabled: isPendingAction, dataTestId: 'confirm-button', children: actionButtonText })] })] }));
});
